import { render, staticRenderFns } from "./top-brand-detail.vue?vue&type=template&id=1387ac62&scoped=true&"
import script from "./top-brand-detail.vue?vue&type=script&lang=js&"
export * from "./top-brand-detail.vue?vue&type=script&lang=js&"
import style0 from "./top-brand-detail.vue?vue&type=style&index=0&id=1387ac62&lang=scss&scoped=true&"
import style1 from "./top-brand-detail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1387ac62",
  null
  
)

export default component.exports